import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import mutationDocument from "./deleteSavedCreditCardMutation.graphql";
import type {
  GetCustomerPaymentInstrumentsRequestResultType,
  InputDeletePaymentType,
  Mutations,
  MutationsDeletePaymentArgs,
} from "@/core/api/graphql/types";

export async function deleteSavedCreditCard(
  payload: InputDeletePaymentType,
): Promise<GetCustomerPaymentInstrumentsRequestResultType> {
  const { userId } = globals;
  payload.userId = userId;
  const { data } = await graphqlClient.mutate<Required<Pick<Mutations, "deletePayment">>, MutationsDeletePaymentArgs>({
    mutation: mutationDocument,
    variables: {
      command: {
        ...payload,
      },
    },
  });

  return data!.deletePayment;
}
